import { render, staticRenderFns } from "./ped_form_pago.vue?vue&type=template&id=785826dc&"
import script from "./ped_form_pago.vue?vue&type=script&lang=js&"
export * from "./ped_form_pago.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports